import { render } from "./KTDataTable.vue?vue&type=template&id=f2b6a846&scoped=true"
import script from "./KTDataTable.vue?vue&type=script&lang=ts"
export * from "./KTDataTable.vue?vue&type=script&lang=ts"

import "./KTDataTable.vue?vue&type=style&index=0&id=f2b6a846&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f2b6a846"

export default script